module.exports = __webpack_public_path__ + "static/media/complete.b6e54fd0.svg";